import React from 'react';
import PropTypes from '@app/utils/propTypes';

import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { MdOutlineSubdirectoryArrowRight } from 'react-icons/md';
import { EllipsisVIcon } from '@patternfly/react-icons';

const PartnerActionsMenu = ({ partner, setActivePartnerId, enterPartnerSpace, setPartnerForm }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const editPartner = (event) => {
        event.stopPropagation();
        setActivePartnerId(partner.id);
        setPartnerForm(true);
    };

    const assumeRole = (event) => {
        event.stopPropagation();
        setActivePartnerId(partner.id);
        enterPartnerSpace(event, partner.id);
    };

    return (
        <Dropdown
            isOpen={isOpen}
            toggle={(event) => {
                event?.stopPropagation();
                setIsOpen(open => !open);
            }}
            direction="start"
        >
            <DropdownToggle
                color="link"
                className="list-actions-toggle"
                aria-label={`Actions for ${partner.name}`}
                onClick={(event) => event.stopPropagation()}
            >
                <EllipsisVIcon />
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem onClick={editPartner}>Edit</DropdownItem>
                <DropdownItem onClick={assumeRole}>Assume Role</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

const PartnersList = ({ headers, partnersData, activePartnerId, setActivePartnerId, enterPartnerSpace, setPartnerForm, ...restProps }) => {
    const [activePartnerExpand, setActivePartnerExpand] = React.useState(null);

    const handleRowClick = (id) => {
        setActivePartnerId(id);
    };

    return (
        <table className="controllers-list-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
                <tr>
                    {headers.map((item, index) => (
                        <th key={index}>
                            <div className={`d-flex align-items-center ${index === 0 || index === 4 || index === 6 ? 'justify-content-center' : 'justify-content-start'}`}>
                                <strong>{item}</strong>
                            </div>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {partnersData.map(({ name, id, contactEmail, controllers, sites, children }, index) => (
                    <React.Fragment key={index}>
                        <tr 
                            className={`${activePartnerId === id ? 'table-active' : ''}`}
                            style={{ cursor: 'pointer' }}
                        >
                            <td className="text-center" onClick={() => setActivePartnerExpand(activePartnerExpand === id ? null : id)}>
                                {children && children.length > 0 && (
                                    <span>
                                        {children.length}
                                        <b className="ms-2">{activePartnerExpand === id ? '▼' : '▶'}</b>
                                    </span>
                                )}
                            </td>
                            <td className="text-start" onClick={() => handleRowClick(id)}>
                                <strong>{name || '-'}</strong>
                            </td>
                            <td className="text-start">{id || '-'}</td>
                            <td className="text-start">{contactEmail || '-'}</td>
                            <td className="text-center">{controllers || '-'}</td>
                            <td className="text-start">{sites || '-'}</td>
                            <td className="text-center partners-action">
                                <PartnerActionsMenu
                                    partner={{ id, name }}
                                    setActivePartnerId={setActivePartnerId}
                                    enterPartnerSpace={enterPartnerSpace}
                                    setPartnerForm={setPartnerForm}
                                />
                            </td>
                        </tr>

                        {children && children.length > 0 && activePartnerExpand === id && (
                            <>
                                {children.map((child, childIndex) => (
                                    <tr key={childIndex}
                                        onClick={() => handleRowClick(child.id)}
                                        className={`child-row ${activePartnerId === child.id ? 'table-active' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td className="text-center"><MdOutlineSubdirectoryArrowRight /></td>
                                        <td className="text-start">{child.name || '-'}</td>
                                        <td className="text-start">{child.id || '-'}</td>
                                        <td className="text-start">{child.contactEmail || '-'}</td>
                                        <td className="text-center">{child.controllers || '-'}</td>
                                        <td className="text-start">{child.sites || '-'}</td>
                                        <td className="text-center partners-action" onClick={(event) => event.stopPropagation()}>
                                            <PartnerActionsMenu
                                                partner={child}
                                                setActivePartnerId={setActivePartnerId}
                                                enterPartnerSpace={enterPartnerSpace}
                                                setPartnerForm={setPartnerForm}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
};

PartnersList.propTypes = {
  headers: PropTypes.node,
  partnersData: PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        key: PropTypes.string,
        parent_id: PropTypes.string,
        created: PropTypes.date,
        updated: PropTypes.date,
        acknowledgedTerms: PropTypes.string,
        contactFirstName: PropTypes.string,
        contactLastName: PropTypes.string,
        contactEmail: PropTypes.string,
        contactPhone: PropTypes.string,
        controllers: PropTypes.string,
        sites: PropTypes.string,
        children: PropTypes.array
    })
  ),
  activePartnerId: PropTypes.string,
  setActivePartnerId: PropTypes.func,
  enterPartnerSpace: PropTypes.func,
  setPartnerForm: PropTypes.func
};

PartnersList.defaultProps = {
  headers: [],
  partnersData: [],
};

export default PartnersList;
